import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import PropTypes from 'prop-types';

const DropdownPM = ({ name = '', placeholder = '', options = [], value = '', onChange = null, disabled = false, emptyMessage, className = '' }) => {
  DropdownPM.propTypes = {
    name: PropTypes.string,
    placeholder: PropTypes.string,
    options: PropTypes.array,
    value: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    emptyMessage: PropTypes.string,
  };

  return (
    <div className={`Dropdown ${className}`}>
      <Dropdown
        name={name}
        placeholder={placeholder}
        options={options}
        value={value}
        onChange={onChange}
        disabled={disabled}
        emptyMessage={emptyMessage}
      />
    </div>
  );
};

export default DropdownPM;